/* @jsx React.createElement */
import { create } from 'zoid';
import {isDevice} from '../../utils'
import {WALLONIE, BRUXELLES, HABITATION, TERRAIN, AUTRE_TYPE_IMMEUBLE} from '../../store/constants/questions'
import {containerTemplate} from './containerTemplate'
export let EasyScalePopup = create({

    tag: 'popup',

    defaultEnv: 'development',

    url: {
        development:       './popup.html',
        production:       'https://embed.easyscale.be/popup.html',
    },

    domain: {
        test: 'mock://www.my-site.com'
    },
    scrolling: true,
    props: {

        prix: {
            type:  'number',
            required: false
        },
        typeBien: {
            type: 'string',
            required: false,
            validate: function(value, props) {
                return (value === HABITATION || value === TERRAIN || value === AUTRE_TYPE_IMMEUBLE || value === undefined)
            }
        },
        region: {
            type: 'string',
            required: false,

            validate: function(value, props) {
                return (value === WALLONIE || value === BRUXELLES || value === undefined)
            }
        },
        organisationId: {
            type: 'string',
            required: true,
        }
    },

    defaultContext: 'iframe',

    contexts: {
        iframe: true,
        popup:  false
    },

    get dimensions(){

        if (isDevice()) {
            return {
                width:  '100%',
                height: '535px'
            };
        }

        return {
            width:  '450px',
            height: '535px'
        };
    },
    containerTemplate,
});



// WEBPACK FOOTER //
// ./src/zoid/popup/component.js